export const locale = {
  lang: 'en-CA',
  data: {
    AUTOMATIONS: {
      CREATE_NEW: 'New automation',
      EDIT_TITLE: 'Edit automation',
      FILTER: 'Filter…',
      NO_RESULTS: 'No automations yet. Click + to create one.',
      NAME: 'Name',
      WHAT: 'What',
      WHEN: 'When',
      PARAM: 'Parameter',
      ACTION: 'Action',
      ACTIVE: 'Active',
      LAST_RUN: 'Last run',
      NEXT_RUN: 'Next',
      NEVER_RUN: 'Never ran',
      PAUSE_TOOLTIP: 'Pause (configuration is kept)',
      ACTIVATE_TOOLTIP: 'Activate (next run will be recomputed)',
      RUN_NOW: 'Run now',
      RUN_NOW_CONFIRM:
        'The report will be generated and emailed immediately to the configured recipients. Continue?',
      RUN_NOW_SUCCESS: 'Run started — the email will go out shortly.',
      RUN_NOW_CONFIRM_EVENT:
        'A fictitious sample payment, marked [TEST], will be sent immediately to the configured destination. Continue?',
      RUN_NOW_SUCCESS_EVENT: 'Sample sent — check the configured destination.',
      TRIGGER: 'Trigger',
      TRIGGER_SCHEDULE: 'Scheduled',
      TRIGGER_EVENT: 'On event',
      TRIGGER_EVENT_SELECT: 'Event',
      WHEN_EVENT: 'On event: {{event}}',
      TASK_NOTIFICATION: 'Notification',
      TASK_NOTIFICATION_HINT:
        'On each event, a notification with the payment details (invoice, client, amount) is delivered to the chosen destination.',
      PARAM_NONE: '—',
      ACTION_WEBHOOK: 'Webhook',
      WEBHOOK_URL: 'Webhook URL (https)',
      WEBHOOK_SECRET: 'Secret (optional)',
      WEBHOOK_SECRET_KEPT:
        'A secret is already stored. Leave blank to keep it.',
      WEBHOOK_HINT:
        'A JSON POST is sent to this URL. With a secret, the "Signature" header carries the HMAC-SHA256 of the JSON body.',
      EMAIL_SUBJECT: 'Email subject (optional)',
      EMAIL_SUBJECT_HINT:
        'Available variables: {number} (invoice number), {amount} (amount), {client} (client name).',
      SUMMARY_EVENT:
        'On each "{{event}}", send a notification to {{recipients}} recipient(s).',
      SUMMARY_EVENT_WEBHOOK: 'On each "{{event}}", send a webhook to {{host}}.',
      CREATE_SUCCESS: 'Automation created',
      EDIT_SUCCESS: 'Automation updated',
      TASK_REPORT: 'Report',
      TASK_TYPE: 'Task type',
      TASK_PROPOSAL_FOLLOWUP: 'Proposal follow-up',
      TASK_PROPOSAL_FOLLOWUP_HINT:
        'Every day at the chosen time, clients whose proposal is still pending receive a follow-up email at the configured steps (days after the proposal was sent). Follow-ups stop as soon as the proposal is accepted, declined or expired, or the event is cancelled or past.',
      FOLLOWUP_STEP_1: '1st follow-up (days)',
      FOLLOWUP_STEP_2: '2nd follow-up (days)',
      FOLLOWUP_STEP_3: '3rd follow-up (days)',
      FOLLOWUP_STEPS_INVALID:
        'Follow-ups must be increasing day counts between 1 and 60.',
      FOLLOWUP_STEPS_HINT:
        'Counted from the day the proposal was sent. At most one follow-up per proposal per day; proposals sent long before activation are not chased.',
      FOLLOWUP_TEMPLATE_HINT:
        'The text sent to the client is edited in Settings → Notification messages → “Proposal follow-up”. Replies go straight to the responsible seller.',
      FOLLOWUP_NOTIFY_INTERNAL: 'Send a daily summary to the recipients below',
      FOLLOWUP_NOTIFY_SELLER:
        'Send each responsible seller the list of their followed-up proposals',
      FOLLOWUP_EMAIL_HINT:
        'Recipients of the internal summary (multiple addresses: separate them with a comma). Clients only receive the follow-up email.',
      SUMMARY_FOLLOWUP:
        '{{when}}, email the clients whose proposal is pending ({{steps}} after sending) and send the summary to {{recipients}} recipient(s).',
      RUN_NOW_CONFIRM_FOLLOWUP:
        'A [TEST] preview of the follow-ups that would go out today will be emailed to you. No client will receive an email. Continue?',
      RUN_NOW_SUCCESS_FOLLOWUP: 'Preview started — check your inbox.',
      REPORT: 'Report',
      PAPER: 'Paper',
      PAPER_LETTER: 'Letter',
      PAPER_LEGAL: 'Legal',
      ORIENTATION: 'Orientation',
      ORIENTATION_PORTRAIT: 'Portrait',
      ORIENTATION_LANDSCAPE: 'Landscape',
      LANGUAGE: 'Language',
      FREQ_DAILY: 'Every day',
      FREQ_WEEKLY: 'Every week',
      FREQ_MONTHLY: 'Every month',
      MONTH_DAY: 'Day of month',
      TIME: 'Time',
      SELECT_AT_LEAST_ONE_DAY: 'Select at least one day',
      PERIOD: 'Report period',
      PERIOD_HINT:
        '"Tomorrow" is resolved at send time: run on the 7th at 7 PM, the period will be the 8th.',
      DAYS_COUNT: 'Number of days',
      PRESET_TODAY: 'Today',
      PRESET_TOMORROW: 'Tomorrow',
      PRESET_NEXT_N_DAYS: 'Next {{n}} days',
      PRESET_NEXT_N_DAYS_OPTION: 'Next N days',
      PRESET_CURRENT_WEEK_PLUS_2: 'Current week + 2 weeks (Monday to Sunday)',
      ACTION_TYPE: 'Destination',
      ACTION_EMAIL: 'Email',
      ACTION_GOOGLE_DRIVE: 'Google Drive',
      ACTION_ONEDRIVE: 'OneDrive',
      ONEDRIVE_HINT:
        'The report is dropped into the OneDrive app folder linked to the organization (Settings → Integrations → OneDrive): PDF and Excel as-is.',
      DRIVE_HINT:
        'The report is dropped into the Google Drive linked to the organization (Settings → Integrations → Google Drive): PDF as-is, Excel converted to a Google Sheet.',
      DRIVE_OVERWRITE: 'Replace the same file on every run',
      DRIVE_OVERWRITE_SHORT: 'single file',
      DRIVE_OVERWRITE_HINT:
        'Checked: one file named after the report, updated on every run (stable link). Unchecked: a new dated copy on every run.',
      EMAIL_TO: 'To',
      EMAIL_CC: 'Cc',
      EMAIL_BCC: 'Bcc',
      EMAIL_HINT: 'Multiple addresses: separate them with a comma.',
      WHEN_DAILY: 'Every day at {{time}}',
      WHEN_WEEKLY: 'Every {{days}} at {{time}}',
      WHEN_MONTHLY: 'On the {{day}} of the month at {{time}}',
      DAY_MO: 'Mon',
      DAY_TU: 'Tue',
      DAY_WE: 'Wed',
      DAY_TH: 'Thu',
      DAY_FR: 'Fri',
      DAY_SA: 'Sat',
      DAY_SU: 'Sun',
      DAY_SHORT_MO: 'M',
      DAY_SHORT_TU: 'T',
      DAY_SHORT_WE: 'W',
      DAY_SHORT_TH: 'T',
      DAY_SHORT_FR: 'F',
      DAY_SHORT_SA: 'S',
      DAY_SHORT_SU: 'S',
      SUMMARY:
        '{{when}}, send the report "{{report}}" covering {{param}}, to {{recipients}} recipient(s).',
      SUMMARY_DRIVE:
        '{{when}}, drop the report "{{report}}" covering {{param}} into Google Drive.',
      SUMMARY_ONEDRIVE:
        '{{when}}, drop the report "{{report}}" covering {{param}} into OneDrive.',
    },
  },
};
